import { ScheduledReport } from '@givelify/api';
import { getAxiosClient, makeApiRequest } from '@givelify/utils';
import { ThunkAction } from 'redux-thunk';
import { AppState, AppActions } from '..';
import { setScheduledReport } from './actions';
import { initialScheduledReport } from './reducer';

export const noScheduleReportIdError = new Error(
    'Schedule Report Id not found',
);

export const noDoneeIdError = new Error('Donee Id not found');

/**
 * Dispatcher to get schedule Report
 */
export const getScheduledReport = (
    doneeId: number,
): ThunkAction<Promise<boolean>, AppState, undefined, AppActions> => {
    return async (dispatch) => {
        const httpRequest = getAxiosClient().get(
            `/donees/${doneeId}/scheduled-reports`,
        );

        const response = await makeApiRequest<ScheduledReport[]>(httpRequest);
        if (!response.success) return false;

        dispatch(
            setScheduledReport(response.response[0] ?? initialScheduledReport),
        );

        return true;
    };
};
